"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Instagram, Twitter, Youtube } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-4 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted/30 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-wrap justify-center gap-6">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-sm text-foreground-dark transition-all duration-500 hover:text-primary hover:underline underline-offset-4">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com/motorevive",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "https://instagram.com/motorevive",
    label: "Instagram"
  }, {
    icon: Twitter,
    href: "https://twitter.com/motorevive",
    label: "Twitter"
  }, {
    icon: Youtube,
    href: "https://youtube.com/motorevive",
    label: "YouTube"
  }];
  return <footer className="bg-dark-background text-foreground-dark py-8 animate-fade-in-up">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {}
          <div className="flex gap-4">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.label} to={social.href} data-index={i} newTab className="text-foreground-dark/70 transition-all duration-300 hover:text-foreground-dark hover:brightness-125" aria-label={social.label}>
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>

          {}
          <MenuProvider menu_id="18" className="flex-1 flex justify-center">
            <FooterMenuConsumer />
          </MenuProvider>

          {}
          <div className="text-center md:text-right">
            <p className="text-sm text-foreground-dark/70">
              © {currentYear} MotoRevive. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}